import RA from "@/components/forms/Radio.module.css";
import R from "@/components/forms/Radiogroup.module.css";

import type { IpAddressWithType } from "@/modules/network/ipAddress/ipAddressApi.ts";
import { Trans } from "@lingui/react/macro";
import { Radio, RadioGroup } from "react-aria-components";

export function DeleteWithFloatingIp({
    value,
    ipAddress,
    onChange,
}: {
    value: boolean | undefined;
    ipAddress?: IpAddressWithType;
    onChange: (value: boolean) => void;
}) {
    if (!ipAddress) {
        return null;
    }

    return (
        <>
            <p className="pt-3 pb-3">
                <Trans>
                    You have a floating IP <b>{ipAddress.address}</b> assigned to this resource.
                </Trans>
            </p>

            <p className="font-size-subtitle pb-2">
                <Trans>What would you like to do?</Trans>
            </p>
            <RadioGroup
                className={R.RadioGroup}
                aria-label="Action"
                value={value == null ? undefined : value ? "yes" : "no"}
                orientation="horizontal"
                onChange={(value) => onChange(value === "yes")}
            >
                <Radio className={RA.Radio} value="no">
                    <Trans>Keep floating IP</Trans>
                </Radio>
                <Radio className={RA.Radio} value="yes">
                    <Trans>Delete floating IP</Trans>
                </Radio>
            </RadioGroup>
        </>
    );
}
